module.exports = __webpack_public_path__ + "static/media/generated.9e38b23a.srt";